import {AlertTypes, GenericFormContainer, IAlertData, Leap4Breadcrumbs, Mode, setAlert, Spinner, MuiIcons} from "@leap4/frontend";
import {useEffect, useMemo, useState} from "react";
import {connect, ConnectedProps} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import {useQuery} from "react-query";
import {initialUserObj, IUser} from "../users/users.inteface";
import {getObjectById} from "../../../../actions/getObjectData";
import {userBaseUrl} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {createNewObject, updateObjectById} from "../../../../actions/creatingObjectsFunc";
import {UserContex} from "../base/userContex";
import {DetailsForm} from "../base/DetailsForm";

const { Create: CreateIcon } = MuiIcons;




export interface IEditGroupProps extends PropsFromRedux {
    setGroup: (data: IAlertData) => void;
}

const mapStateToProps = () => ({});

const mapActions = {
    setAlert
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;


const _manageUser = (props: IEditGroupProps) => {
    const params = useParams<{ id?: string }>();
    const history = useHistory();
    const [user, setUser] = useState<IUser>(initialUserObj);

    const editUserDataContextValue = useMemo(() => ({
        user,
        setUser,

    }), [user, setUser]);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)


    const fetchUserById = async () => {
        if(!params.id) {
            return;
        }
        const userData = await getObjectById(userBaseUrl,params.id) as IUser;
        setUser(userData)
    }

    useQuery('fetchUserById', fetchUserById, {
        refetchOnWindowFocus: false,
        onError: (err: any) => {
            console.log("there was an error on getting headerViewData")
        }
    });


    const onSubmit = async () => {
        try {
            setIsLoading(true)
            if(params.id) {
                console.log("updateObjectById", user)
                await updateObjectById(params.id, user, userBaseUrl);
            }else{
                await createNewObject(user, userBaseUrl);
            }
        } catch (err) {
            console.log("gotError", err)
            setAlert({msg: err.toString(), type: AlertTypes.FAILURE})
        } finally {
            setIsLoading(false)
        }
        setAlert({msg: "created new page view", type: AlertTypes.SUCCESS})
        history.push(urlService.users());
    };


    useEffect(() => {
        if (!params.id) {
            return;
        }

    }, [params.id])

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "user management dashboard",
                link: urlService.users(),
                icon: <CreateIcon/>
            },
                {
                    text: "user view settings",
                    icon: <CreateIcon/>
                }

            ]}
            />
            <GenericFormContainer mode={params.id ? Mode.Edit:Mode.Create} onCreateOrEditFunc={onSubmit}
                                  buttonsProps={{delete: {"disabled": true}}}>
                <UserContex.Provider value={editUserDataContextValue}>
                    <DetailsForm mode={params.id ? "edit": "create"}/>
                </UserContex.Provider>
            </GenericFormContainer>
        </>
    )
}

export const ManageUser = connect(mapStateToProps, {
    setAlert
})(_manageUser);
